$(function() {
	$('.carousel').carousel();
});